var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "pcpdaClass" }, [_vm._v("PC")]),
      _c("el-tree", {
        ref: "treeRefPC",
        attrs: {
          "check-strictly": true,
          data: _vm.permissionList.pc,
          props: _vm.props,
          "icon-class": "el-icon-thumb",
          "node-key": "id",
          "show-checkbox": "",
        },
        on: { check: _vm.handleTreeCheckPC },
      }),
      _c(
        "div",
        { staticClass: "pcpdaClass", staticStyle: { "margin-top": "20px" } },
        [_vm._v("PDA")]
      ),
      _c("el-tree", {
        ref: "treeRefPDA",
        attrs: {
          "check-strictly": true,
          data: _vm.permissionList.pda,
          props: _vm.props,
          "icon-class": "el-icon-thumb",
          "node-key": "id",
          "show-checkbox": "",
        },
        on: { check: _vm.handleTreeCheckPDA },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }